import { registerComponent } from '@gig/magic-common';
import UserInfoComponent from './user-info.vue.js';

var UserInfo = registerComponent(UserInfoComponent);

export { UserInfo };
